import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureLoginAccountSummary(props) {
    return <AccountSummaryPage />
}